<script>
	import { navigate } from "svelte-routing";
	import { Breadcrumb, BreadcrumbItem } from "@sveltestrap/sveltestrap";

	export let links = [];
</script>

<div>
	<Breadcrumb>
		{#each links as link, index}
			<BreadcrumbItem>
				{#if index === links.length - 1 || !link.to}
					<span>
						{link.label}
					</span>
				{:else}
					<span
						class="link link-text"
						on:click={() => navigate(link.to)}
						on:keydown={() => {}}
					>
						{link.label}
					</span>
				{/if}
			</BreadcrumbItem>
		{/each}
	</Breadcrumb>
</div>
